// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import { DIALOG_CLOSE_EVENTS } from '../StdDialog/types';
export const ACTION_EVENT_TYPES = ['CONFIRM', 'DENY', ...DIALOG_CLOSE_EVENTS];

type ConfirmationDialogPropsProps = {
  title: ?string,

  content: ?string,
  contentViewId: ?string,

  confirmLabel: string,
  denyLabel: string,

  confirmAction: ?Object | ?(ACTION_EVENT_TYPES) => void,
  denyAction: ?Object | ?(ACTION_EVENT_TYPES) => void,

  dialogCloseAliasAction: ACTION_EVENT_TYPES,

  textEntryConfirmationText: ?string,
  unregisterContentViewOnClose: boolean,
}
export type ConfirmationDialogProps = RecordOf<ConfirmationDialogPropsProps>;
export const mkConfirmationDialogProps: RecordFactory<ConfirmationDialogPropsProps> =
  Record({
    title: null,

    content: null,
    contentViewId: null,

    confirmLabel: 'OK',
    denyLabel: 'Cancel',

    confirmAction: null,
    denyAction: null,

    dialogCloseAliasAction: 'CONFIRM',

    textEntryConfirmationText: null,
    unregisterContentViewOnClose: false,
  });

export const DIALOG_TYPE = 'DIALOG_CONFIRMATION';

